import { AnchorElement } from '@thiememeulenhoff/lit-sdk';
import {
  customElement,
  property,
  queryAssignedElements,
} from 'lit/decorators.js';
import { tagName } from '../../../helpers';
import { IconComponent } from '../../icon';
import { styles } from './toc-action.styles';

const tag = tagName('toc-action');

@customElement(tag)
export class TocActionComponent extends AnchorElement {
  @property({ type: Boolean, reflect: true })
  flex = false;

  @queryAssignedElements({ selector: 'a-icon' })
  slottedIcons!: Array<IconComponent>;

  static override styles = styles;

  override connectedCallback() {
    super.connectedCallback();

    this.slot = 'actions';
  }

  protected override onSlotChanged() {
    if (this.slottedIcons.length) {
      this.classList.add('toc-action--has-icon');
    } else {
      this.classList.remove('toc-action--has-icon');
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'a-toc-action': TocActionComponent;
  }
}
